import React from 'react';

import { get } from 'dpl/shared/utils/object';
import ErrorWrapper from 'dpl/form/components/ErrorWrapper';
import FullPageQuizTextInput from 'dpl/components/FullPageQuiz/FullPageQuizTextInput';
import FullPageQuizQuestion from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';
import useFormContext from 'dpl/shared/form/hooks/useFormContext';

import { FORM_BUYER_POSTAL_CODE } from '../utils/constants';

export default function QuizZipcodeQuestion(props) {
  const { formState, formErrors, handleFormFieldChange } = useFormContext();

  const zipcode = get(formState, FORM_BUYER_POSTAL_CODE) || '';
  const errors = formErrors[FORM_BUYER_POSTAL_CODE] || [];

  return (
    <div className="BuyerProfileQuizZipcodeQuestion">
      <FullPageQuizQuestion
        title="Where are you located?"
        subtitle="Breeders like to get a sense of distance."
        newDesignSystemStyles
        {...props}
      >
        <ErrorWrapper errors={errors} newDesignSystemStyles>
          <FullPageQuizTextInput
            className="mb1"
            id={FORM_BUYER_POSTAL_CODE}
            name={FORM_BUYER_POSTAL_CODE}
            onChange={handleFormFieldChange}
            type="text"
            value={zipcode}
            placeholder="Zip code"
            newDesignSystemStyles
            labelText="Zip code"
            hasErrors={errors.length > 0 && zipcode.length > 0}
          />
        </ErrorWrapper>
      </FullPageQuizQuestion>
    </div>
  );
}
